import { render } from "./ReferenceCardsList.vue?vue&type=template&id=e8abb00c&scoped=true"
import script from "./ReferenceCardsList.vue?vue&type=script&lang=js"
export * from "./ReferenceCardsList.vue?vue&type=script&lang=js"

import "./ReferenceCardsList.vue?vue&type=style&index=0&id=e8abb00c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8abb00c"]])

export default __exports__